import {
  Box,
  Flex,
  Heading,
  Image,
  List,
  Stack,
  Table,
  TableCellProps,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  UnorderedList,
} from '@chakra-ui/react';
import { FC, forwardRef } from 'react';
import { User } from '@frx/frx-react-context';
import { TeamRaiserInfo } from '@frx/frx-services';
import { SJLogoBlack } from '../../assets';

export interface GiftFormProps {
  consId?: User['cons_id'];
  eventCode?: string;
  eventName?: TeamRaiserInfo['name'];
  sourceCode?: string;
  userName?: string;
}

const GiftTextArea = () => (
  <Textarea minH="3rem" resize="none" borderColor="brand.additional.black" />
);

const GiftTableData: FC<TableCellProps> = (props) => (
  <Td p={1} {...props}>
    <GiftTextArea />
  </Td>
);

export const GiftForm = forwardRef<HTMLDivElement, GiftFormProps>(
  // eslint-disable-next-line react/prop-types
  (
    { consId, eventCode, eventName, sourceCode, userName },
    ref
  ): JSX.Element => (
    <div ref={ref as any}>
      <Box display={['flex', 'flex', 'block']} justifyContent="center" pb={4}>
        <Image src={SJLogoBlack} alt="St.Jude logo" />
      </Box>
      <Stack>
        <Flex direction="column">
          <Heading fontSize="md" alignSelf="center">
            Heroes Check Submission Form
          </Heading>
          <Box py={2}>
            <Text
              align="left"
              fontWeight="bolder"
              borderColor="black"
              borderTopWidth="2px"
              borderBottomWidth="2px"
              py={2}
            >
              {`Please include your ID # (${consId}) on the checks that are mailed in
            with the form. Please convert cash to check or money order. Mail
            checks and form to the following address.`}
            </Text>
          </Box>
        </Flex>
        <TableContainer>
          <Table colorScheme="brand.additional.black" variant="unstyled">
            <Thead>
              <Tr>
                <Th textAlign="center">Donor Name</Th>
                <Th textAlign="center">Street Address</Th>
                <Th textAlign="center">City,State,Zip</Th>
                <Th textAlign="center">Check #</Th>
                <Th textAlign="center">Amount</Th>
              </Tr>
            </Thead>
            <Tbody>
              {[...Array(10)].map((e, i) => (
                <Tr key={i} p={0}>
                  <GiftTableData w="20%" />
                  <GiftTableData />
                  <GiftTableData />
                  <GiftTableData w="15%" />
                  <GiftTableData w="9%" />
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        <Box border="1px solid black" p={2}>
          <Heading fontSize="md">For Internal Use Only</Heading>
          <List>
            <UnorderedList>
              <Text>Participant Name: {userName}</Text>
              <Text>Event Name: {eventName}</Text>
              <Text>ID (P2PCONV): {consId}</Text>
              <Text>Source Code: {sourceCode}</Text>
              <Text>Event Code: {eventCode}</Text>
            </UnorderedList>
          </List>
        </Box>
      </Stack>
    </div>
  )
);

GiftForm.displayName = 'GiftForm';
